class PDPPWWLayout {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector(".pdp-pww-track");
    this.swiper = null;

    this.init();

    window.addEventListener("resize", () => this.init());
  }

  getLayout() {
    return window.innerWidth >= 768
      ? this.container.classList.contains("desktop-carousel")
        ? "carousel"
        : "stacked"
      : this.container.classList.contains("mobile-carousel")
      ? "carousel"
      : "stacked";
  }

  init() {
    const layout = this.getLayout();

    if (layout === "carousel") {
      this.enableCarousel();
    } else {
      this.disableCarousel();
    }
  }

  enableCarousel() {
    if (this.swiper) return;

    this.container.classList.add("is-carousel");

    this.container.classList.add("swiper");
    this.track.classList.add("swiper-wrapper");

    [...this.track.children].forEach(item => {
      item.classList.add("swiper-slide");
    });

    this.swiper = new Swiper(this.container, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      }
    });

    this.bindNestedScroll();
  }

  bindNestedScroll() {
  this.container.querySelectorAll(".color-swatches").forEach(el => {
    el.addEventListener("mouseenter", () => {
      this.swiper?.mousewheel.disable();
    });

    el.addEventListener("mouseleave", () => {
      this.swiper?.mousewheel.enable();
    });
  });
}

  disableCarousel() {
    this.container.classList.remove("is-carousel");

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.container.classList.remove("swiper");
    this.track.classList.remove("swiper-wrapper");

    [...this.track.children].forEach(item => {
      item.classList.remove("swiper-slide");
      item.removeAttribute("style");
    });
  }
}

document.querySelectorAll(".pdp-pww-list").forEach(el => {
  new PDPPWWLayout(el);
});
